// extracted by mini-css-extract-plugin
export default {"CustomSectionHeader":"CustomSectionHeader_CustomSectionHeader__NWYxY","Heading":"CustomSectionHeader_Heading__MGFlO","Subheading":"CustomSectionHeader_Subheading__MzM1Y"};